import { FC } from 'react'
import { Modal } from 'react-bootstrap'

type AdvanceSettings = {
  export_file_type?: string
  csv_delimeter?: string
  mail_notification?: boolean
  mail_address?: string
  group_by?: string
}

type Props = {
  show: boolean
  onHide: () => void
  data: AdvanceSettings | null
}

export const AdvanceSettingsModal: FC<Props> = ({ show, onHide, data }) => {
  const d = data || {}
  return (
    <Modal show={show} onHide={onHide} size='lg' centered>
      <Modal.Header closeButton>
        <Modal.Title>Download Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='mb-4'>
          <div className='text-muted fw-semibold mb-2'>JSON</div>
          <pre
            className='bg-light rounded p-3 mb-0'
            style={{ maxHeight: '50vh', overflow: 'auto' }}
          >
            {JSON.stringify(d, null, 2)}
          </pre>
        </div>
        <div className='mb-2'>
          <div className='text-muted fw-semibold mb-2'>Details</div>
          <div className='table-responsive'>
            <table className='table table-sm align-middle'>
              <tbody>
                <tr>
                  <td className='text-muted' style={{ width: '30%' }}>
                    Export File Type
                  </td>
                  <td>
                    <span className='badge badge-light-primary'>
                      {(d as any).export_file_type?.toString().toUpperCase() || 'CSV'}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className='text-muted'>CSV Delimiter</td>
                  <td>
                    <code>{(d as any).csv_delimeter || ','}</code>
                  </td>
                </tr>
                <tr>
                  <td className='text-muted'>Mail Notification</td>
                  <td>
                    {(d as any).mail_notification ? (
                      <span className='badge badge-light-success'>Yes</span>
                    ) : (
                      <span className='badge badge-light-secondary'>No</span>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className='text-muted'>Mail Address</td>
                  <td>{(d as any).mail_address || '-'}</td>
                </tr>
                <tr>
                  <td className='text-muted'>Group By</td>
                  <td>
                    <span className='badge badge-light-info'>
                      {(((d as any).group_by || 'meter') + '').charAt(0).toUpperCase() +
                        (((d as any).group_by || 'meter') + '').slice(1)}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type='button' className='btn btn-light' onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  )
}
